import { CircularProgress as MuiCircularProgress, type CircularProgressProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

type TCircularProgressProps = CircularProgressProps & {
  wrapperClass?: string;
};

const useStyles = makeStyles(() => ({
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 2,
  },
}));

export const CircularProgress = ({ wrapperClass, size = 28, ...props }: TCircularProgressProps) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.circularProgress, wrapperClass)} data-testid="circularProgress">
      <MuiCircularProgress color="primary" size={size} {...props} />
    </div>
  );
};
